<script setup lang="ts">
import WebsiteLayout from "@layouts/website-layout.vue";
import {defineAsyncComponent, onMounted, PropType} from "vue";
import {router, usePage} from "@inertiajs/vue3";
import {PagePropsInterface} from "@interfaces/PagePropsInterface.js";
import {BlogInterface} from "@interfaces/BlogInterface.js";
import AppHead from "@layouts/sections/app-head.vue";
import Products from "./sections/products.vue";
import {ProductsInterface} from "@interfaces/ProductsInterface.js";
import Hero from "./sections/hero.vue";
import { trans } from 'laravel-vue-i18n';

let page = usePage<PagePropsInterface>();

const props = defineProps<{
    blogs?: BlogInterface[],
    preConfigs?: ProductsInterface[]
}>();

defineOptions(
    {
        layout: WebsiteLayout,
    }
)

onMounted(() => {
    router.reload({
        only: [
            'blogs',
            'preConfigs'
        ]
    })
    page.props.headerOptions = {
        transparent: true,
        inverted: false,
    }
})

const Why = defineAsyncComponent(()=> import('./sections/why.vue'))
const Reviews = defineAsyncComponent(()=> import('./sections/reviews.vue'))
const App = defineAsyncComponent(()=> import('./sections/app.vue'))
const Blogs = defineAsyncComponent(()=> import('./sections/blogs.vue'))

</script>
<template>
    <div id="page-index">
        <app-head
            :title="trans('pages.home.title')"
            :description="trans('pages.home.description')">
        </app-head>
        <hero></hero>
        <products
            v-if="props.preConfigs"
            :pre-configs="props.preConfigs"
            category-slug="standing-desk"
            :name="{singular: 'standing desk', plural: 'standing desks'}"
        ></products>
        <why></why>
        <reviews></reviews>
        <app></app>
        <blogs
            v-if="props.blogs"
            :blogs="props.blogs"
        >
        </blogs>
    </div>
</template>
<style scoped lang="scss">
@use "@scss/pages/home/index";
</style>
